import { Component, Input, OnInit, Renderer2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Constant } from 'src/app/constants/constant';

import { AboutService } from 'src/app/services/about.service';
import { CommonService } from 'src/app/services/common.service';
import { ConfigServiceService } from 'src/app/services/config-service.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'calsoft-general',
  templateUrl: './general.component.html',
  styleUrls: ['./general.component.scss']
})
export class GeneralComponent implements OnInit {
  aboutData: any;
  @Input() public pageTitle: any
  @Input() public homePageBuilder: any;
  loaded: any = false;
  layoutype: any = 0;
  homePageLayoutLoadedMob: any;
  homePageLayoutLoadedWeb: any;
  page: number;
  mobileLayout: boolean;
  size: any;
  author: any;
  description: any;
  keywords: any;
  browserGraphImage: any;
  imageUrl: string;
  metakeywords: any;
  metadescription: any;
  metaauthor: any;
  configData: any;
  constructor(
    private titleService: Title,
    private aboutService: AboutService,
    public meta: Meta, public title: Title,
    private router: Router,
    private renderer: Renderer2,
    private route: ActivatedRoute,
    private commonService: CommonService,
  ) {


  }

  ngOnInit(): void {
    const storedConfig = this.commonService.getConfigData();

    if (storedConfig) {
      this.configData = JSON.parse(storedConfig);
      console.log('Config Loaded:', this.configData);

      // You can now use this.configData.theme, token, etc.
    } else {
      console.warn('No config data found in localStorage.');
    }

    if (this.route.snapshot.params['pageId'] != undefined) {

      this.pageTitle = this.route.snapshot.params['pageId'];
    }

    if (this.router.url.includes('/pages/')) {
      this.pageTitle = this.route.snapshot.params['pageId'];
    }



    this.getConfigData();

    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      this.removeTag();
    });

  }

  removeTag() {
    const metaTagsToRemove = [
      'author', 'keywords', 'description', 'og:image', 'og:url', 'og:description',
      'og:locale', 'og:type', 'twitter:title', 'twitter:description', 'twitter:image', 'twitter:card'
    ];
    metaTagsToRemove.forEach(tag => {
      this.meta.removeTag(`name='${tag}'`);
      this.meta.removeTag(`property='${tag}'`);
    });
  }

  getConfigData() {
         let data = this.configData;

          this.homePageLayoutLoadedMob = data['homePageLayoutLoadedMob'];
          this.homePageLayoutLoadedWeb = data['homePageLayoutLoadedWeb'];
          this.author = data['author'];
          this.description = data['description'];
          this.keywords = data['keywords'];
          this.browserGraphImage = data['browserGraphImage'];



          this.getAboutData();

       
  }
  public serverPath14 = environment.commonImageApi + "browerMediaImage/";


  getAboutData() {

    this.page = 0;
    if (window.innerWidth > 768) {

      this.mobileLayout = false;
      this.size = this.homePageLayoutLoadedWeb == undefined ? 3 : this.homePageLayoutLoadedWeb;
    } else {
      this.mobileLayout = true;
      this.size = this.homePageLayoutLoadedMob == undefined ? 5 : this.homePageLayoutLoadedMob;
    }


    this.aboutService.getPageByIdNew(this.pageTitle, this.page, this.size).subscribe(
      (res) => {
        this.aboutData = res['content'];

        this.layoutype = res['type'];
        this.homePageBuilder = res['homePageBuilder'];
        let currentURL = window.location.href;
        let type = 'article';
        let value = "en_US"

        let imageUrl = this.serverPath14 + this.browserGraphImage;

        if (this.router.url != '/') {
          this.metaauthor = res['rootTemplate'];
          this.metadescription = res['metaDescription'];
          this.metakeywords = res['metaKeywords'];
        }



        if (this.router.url == '/') {

          this.titleService.setTitle(this.author);

        }

      



        if (this.pageTitle != 'footer') {

          this.updateMetaTags();
          this.setCanonicalURL(currentURL);

          const metaTagsToRemove = [
            'author', 'keywords', 'description', 'og:image', 'og:url', 'og:description',
            'og:locale', 'og:type', 'twitter:title', 'twitter:description', 'twitter:image', 'twitter:card'
          ];
          metaTagsToRemove.forEach(tag => this.meta.removeTag(`name='${tag}'`));
          metaTagsToRemove.forEach(tag => this.meta.removeTag(`property='${tag}'`));

          if (this.router.url === '/') {

            const metaTagsToRemove = [
              'author', 'keywords', 'description', 'og:image', 'og:url', 'og:description',
              'og:locale', 'og:type', 'twitter:title', 'twitter:description', 'twitter:image', 'twitter:card'
            ];
            metaTagsToRemove.forEach(tag => this.meta.removeTag(`name='${tag}'`));
            metaTagsToRemove.forEach(tag => this.meta.removeTag(`property='${tag}'`));


            this.meta.addTags([
              { name: 'author', content: Constant.siteName },
              { name: 'keywords', content: this.keywords, },
              { name: 'description', content: this.description },
              { name: 'og:image', content: imageUrl },
              { property: 'og:url', content: currentURL },
              { property: 'og:description', content: this.description },
              { property: 'og:image', content: imageUrl },
              { property: 'og:locale', content: value },
              { property: 'og:type', content: type },

              { property: 'og:image:secure_url', content: imageUrl },
              { property: 'og:image:type', content: "image/png" },
              { property: 'og:image:width', content: "1200" },
              { property: 'og:image:height', content: "630" },


              { name: 'twitter:title', content: this.author },
              { name: 'twitter:description', content: this.description },
              { name: 'twitter:image', content: imageUrl },
              { name: 'twitter:card', content: "summary_large_image" }
            ]);
          } else {

            const metaTagsToRemove = [
              'author', 'keywords', 'description', 'og:image', 'og:url', 'og:description',
              'og:locale', 'og:type', 'twitter:title', 'twitter:description', 'twitter:image', 'twitter:card'
            ];
            metaTagsToRemove.forEach(tag => this.meta.removeTag(`name='${tag}'`));
            metaTagsToRemove.forEach(tag => this.meta.removeTag(`property='${tag}'`));
            

            if (res['rootTemplate'] != undefined) {

              if (res['rootTemplate'] != null) {

                this.meta.addTags([
                  { name: 'author', content: Constant.siteName },
                  { name: 'title', content: this.metaauthor, },
                  { name: 'description', content: this.metadescription },
                  { name: 'og:image', content: imageUrl },
                  { property: 'og:url', content: currentURL },
                  { property: 'og:description', content: this.metadescription },
                  { property: 'og:image', content: imageUrl },
                  { property: 'og:locale', content: value },
                  { property: 'og:type', content: type },

                  { property: 'og:image:secure_url', content: imageUrl },
                  { property: 'og:image:type', content: "image/png" },
                  { property: 'og:image:width', content: "1200" },
                  { property: 'og:image:height', content: "630" },

               
                  

                  { name: 'twitter:title', content: this.metaauthor },
                  { name: 'twitter:description', content: this.metadescription },
                  { name: 'twitter:image', content: imageUrl },
                  { name: 'twitter:card', content: "summary_large_image" }
                ]);
              }
            }

            const newMeta = this.renderer.createElement('meta');
            this.renderer.setAttribute(newMeta, 'name', 'keywords');
            this.renderer.setAttribute(newMeta, 'content', this.metakeywords);
            this.renderer.appendChild(document.head, newMeta);

          }


        }










        this.loaded = true;
      }
    )
  }


  updateMetaTags() {
    const currentUrl = this.router.url;

    if (currentUrl.includes('/private')) {
      this.meta.updateTag({ name: 'robots', content: 'noindex, nofollow' });
    } else {
      this.meta.updateTag({ name: 'robots', content: 'index, follow' });
    }
  }


  setCanonicalURL(url: string) {
    let link: HTMLLinkElement = document.querySelector("link[rel='canonical']");

    if (link) {
      this.renderer.setAttribute(link, 'href', url);
    } else {
      link = this.renderer.createElement('link');
      this.renderer.setAttribute(link, 'rel', 'canonical');
      this.renderer.setAttribute(link, 'href', url);
      this.renderer.appendChild(document.head, link);
    }
  }


}
